<div #analyzeOverview data-testid="analyze-overview" [ngClass]="{ 'h-[30vh] md:h-[80%]': dataState === 'empty-result' }">
    @if (dataState === "no-data") {
        <div data-testid="overview-no-data">
            <div class="mb-16 flex justify-center">
                <div class="mt-16">
                    <div class="text-center items-center">
                        <div class="mt-1">
                            <img class="inline" src="{{ 'activities_nodata_link' | translate }}" width="40%" height="40%" alt="No data" />
                        </div>
                        <div class="mb-12">
                            <h4>{{ "activities_nodata_title" | translate }}</h4>
                            <p [innerHTML]="'activities_nodata_text1' | translate"></p>
                        </div>

                        <p class="mb-2" style="color: #818181">{{ "dashboard_nodata_text2" | translate }}</p>

                        <div class="mb-8">
                            <a [routerLink]="['/apps']">
                                <img class="inline" src="/assets/images/app-icons.png" alt="App icons" width="35%" height="35%" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    @if (dataState === "empty-result") {
        <div data-testid="overview-empty-result" class="card h-full">
            <div class="flex justify-center items-center h-full">
                <div class="flex flex-col items-center">
                    <i class="pi pi-filter text-gray-400 mb-6" style="font-size: 3.5rem"></i>
                    <h4 class="mb-6">{{ "activities_empty_filter_result_heading" | translate }}</h4>
                    <p class="text-gray-500">{{ "activities_empty_filter_result_text" | translate }}</p>
                </div>
            </div>
        </div>
    }

    @if (dataState === "has-data") {
        <div data-testid="overview-report">
            <div class="card chart" id="printContent" name="printContent">
                <div class="overview-bar-chart">
                    <div class="flex justify-between content-center">
                        <div data-testid="overview-total" class="text-xl font-semibold">
                            {{ "activities_total" | translate }}: {{ totalTime | secondsToHoursMinutes }}
                        </div>
                        <div class="flex" style="gap: 1rem; margin-bottom: 0.5rem; align-items: center">
                            <p style="margin: 0">{{ "report_group_by" | translate }}</p>
                            <app-tooltip-dropdown
                                data-testid="overview-bar-group"
                                ngDefaultControl
                                [options]="barchartGroupOptions"
                                [(ngModel)]="barchartGroupSelected"
                                optionLabel="label"
                                (onChange)="changeBarChartGroup()"
                                [disabledTooltip]="'tooltip_pro_reports' | translate"
                            />

                            <p style="margin: 0">{{ "standard_and" | translate }}</p>
                            <p-select
                                data-testid="overview-bar-interval"
                                [options]="barChartIntervalOptions"
                                [(ngModel)]="barChartIntervalSelected"
                                optionLabel="label"
                                (onChange)="changeBarChartInterval()"
                            />
                        </div>
                    </div>
                    <div>
                        <p-chart type="bar" [options]="stackedOptions" [data]="barData" [height]="barChartHeight" legend="display: false"> </p-chart>
                    </div>
                </div>
            </div>

            <div class="card chart">
                <div class="overview-table-doughnut">
                    <div class="flex justify-between content-center">
                        <!--
                        <div class="text-xl font-semibold">
                        <p style="margin:0">
                        {{ 'report_group_by' | translate }} {{tableFirstGroupSelected?.label}}
                        <ng-container *ngIf="tableSecondGroupSelected && tableSecondGroupSelected.id != ''">
                        {{ 'standard_and' | translate }} {{ tableSecondGroupSelected.label }}
                        </ng-container>
                        </p>
                        </div>
                    -->
                        <div class="flex" style="gap: 1rem; margin-bottom: 1rem; align-items: center">
                            <p style="margin: 0">{{ "report_group_by" | translate }}</p>
                            <app-tooltip-dropdown
                                data-testid="overview-table-group-1"
                                ngDefaultControl
                                [options]="tableFirstGroupOptions"
                                [(ngModel)]="tableFirstGroupSelected"
                                optionLabel="label"
                                (onChange)="changeFirstGroup($event.value)"
                                [disabledTooltip]="'tooltip_pro_reports' | translate"
                            />
                            <p style="margin: 0" [ngClass]="{ 'p-disabled': !licenseStatePro }">{{ "standard_and" | translate }}</p>
                            <div pTooltip="{{ (!licenseStatePro ? 'tooltip_pro_reports' : '') | translate }}" tooltipPosition="top">
                                <p-select
                                    data-testid="overview-table-group-2"
                                    [options]="tableSecondGroupOptions"
                                    [(ngModel)]="tableSecondGroupSelected"
                                    optionLabel="label"
                                    (onChange)="changeSecondGroup($event.value)"
                                    [disabled]="!licenseStatePro"
                                />
                            </div>
                            <!--
                            <p-cascadeselect [(ngModel)]="tableSecondGroupSelected" optionLabel="label"></p-cascadeselect>
                        --></div>
                        <!--
                        <div class="flex" style="gap: 1rem; margin-bottom:1rem; align-items:center;">
                        <app-export-actions-panel
                        [licenseStatePro]="licenseStatePro"
                        [exportToPdf]="exportTableToPdf"
                        [exportToExcel]="exportTableToExcel"
                        [exportToCsv]="exportTableToCsv"
                        ></app-export-actions-panel>
                        </div>
                    --></div>
                    <div class="flex flex-wrap">
                        @if (tableSecondGroupSelected && tableSecondGroupSelected.value != "") {
                            <div class="grow lg:mr-20 md:mr-1 sm:mr-1">
                                <p-table
                                    data-testid="overview-report-table"
                                    [value]="tableData"
                                    sortField="group1"
                                    sortMode="single"
                                    dataKey="group1"
                                    rowGroupMode="subheader"
                                    groupRowsBy="group1"
                                    responsiveLayout="scroll"
                                    [paginator]="false"
                                    tableStyleClass="report-group-table"
                                >
                                    <!--
                                    TODO FIXME: Sorting does not work in conjunction with rowGroupMode!!!
                                    [sortOrder]="-1"
                                    (sortFunction)="sortTable($event)"
                                    [customSort]="true"
                                -->
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th style="width: 3rem">
                                                <!--
                                                <button type="button" pButton pRipple
                                                class="p-button-text p-button-rounded p-button-plain mr-2"
                                                [icon]="groupTableAllExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                                (click)="expandCollapseAll()">
                                                </button>
                                            --></th>
                                            <th pSortableColumn="group1">
                                                {{ tableFirstGroupSelected?.label }}
                                                <p-sortIcon field="group1"></p-sortIcon>
                                            </th>
                                            <th pSortableColumn="group2">
                                                {{ tableSecondGroupSelected.label }}
                                                <p-sortIcon field="group2"></p-sortIcon>
                                            </th>
                                            <th pSortableColumn="durationSeconds">
                                                {{ "activities_duration" | translate }}
                                                <p-sortIcon field="durationSeconds"></p-sortIcon>
                                            </th>
                                            <th>{{ "activities_total" | translate }}</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="groupheader" let-tableData let-expanded="expanded">
                                        <tr data-testid="overview-group-header">
                                            <!-- <tr pRowGroupHeader> -->
                                            <td>
                                                <button
                                                    type="button"
                                                    pButton
                                                    pRipple
                                                    [pRowToggler]="tableData"
                                                    class="p-button-text p-button-rounded p-button-plain mr-2"
                                                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                                ></button>
                                            </td>
                                            <td colspan="3">
                                                <div style="float: left; margin-right: 1rem; padding-top: 0.1rem">
                                                    <div class="center-wrapper">
                                                        <div
                                                            [style.background-color]="tableData.backgroundColor"
                                                            [style.border]="getBorder(tableData)"
                                                            class="circle"
                                                        ></div>
                                                    </div>
                                                </div>
                                                <div style="float: left; padding-bottom: 0.1rem">{{ tableData.group1 }}</div>
                                            </td>
                                            <td>{{ calculateTotalDuration(tableData.group1) | secondsToHoursMinutes }}</td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="expandedrow" let-tableData>
                                        <tr data-testid="overview-group-row" class="group-row">
                                            <td></td>
                                            <td></td>
                                            <td>{{ tableData.group2 }}</td>
                                            <td>{{ tableData.durationSeconds | secondsToHoursMinutes }}</td>
                                            <td></td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="paginatorleft"> </ng-template>
                                    <ng-template pTemplate="paginatorright"> </ng-template>
                                </p-table>
                            </div>
                        } @else if (!tableSecondGroupSelected || tableSecondGroupSelected.value == "") {
                            <!-- display original table without rowGroupMode when only grouped by one condition to make sorting work -->
                            <div class="grow lg:mr-20 md:mr-1 sm:mr-1">
                                <p-table
                                    data-testid="overview-report-table"
                                    [value]="tableData"
                                    responsiveLayout="scroll"
                                    [paginator]="true"
                                    sortField="durationSeconds"
                                    [sortOrder]="-1"
                                    [rowsPerPageOptions]="[paginationRows, 50]"
                                    [rows]="paginationRows"
                                    (onPage)="onPaginationChange($event)"
                                    [showCurrentPageReport]="true"
                                    currentPageReportTemplate="{{ 'table_pagination_showing' | translate }} {first} {{
                                        'table_pagination_to' | translate
                                    }} {last} {{ 'table_pagination_of' | translate }} {totalRecords} {{ 'table_pagination_entries' | translate }}"
                                >
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th style="width: 3rem"></th>
                                            <th pSortableColumn="group1">
                                                {{ tableFirstGroupSelected?.label }}
                                                <p-sortIcon field="group1"> </p-sortIcon>
                                            </th>
                                            <th pSortableColumn="durationSeconds">
                                                {{ "activities_duration" | translate }}
                                                <p-sortIcon field="durationSeconds"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-tableData>
                                        <tr data-testid="overview-table-row">
                                            <td></td>
                                            <td>
                                                <div style="float: left; margin-right: 1rem; padding-top: 0.1rem">
                                                    <div class="center-wrapper">
                                                        <div
                                                            [style.background-color]="tableData.backgroundColor"
                                                            [style.border]="getBorder(tableData)"
                                                            class="circle"
                                                        ></div>
                                                    </div>
                                                </div>
                                                <div style="float: left; padding-bottom: 0.1rem">{{ tableData.group1 }}</div>
                                            </td>
                                            <td>{{ tableData.durationSeconds | secondsToHoursMinutes }}</td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="paginatorleft"> </ng-template>
                                    <ng-template pTemplate="paginatorright"> </ng-template>
                                </p-table>
                            </div>
                        }
                        <div class="flex-none">
                            <p-chart type="doughnut" [data]="pieData" [options]="pieOptions" [height]="pieChartHeight" style="width: 300px">"> </p-chart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
